export default {
  getStateSoukecityId (state) {
    return state.soukecityId
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js